import { useMemo } from "react";

import { querygetCorporationProfileInfo } from "@type/api/corporation/getCorpProfileInfo";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TCreateCorpRes } from "@type/api/corporation/types";

interface UseGetCorpBasicInfoProps {
  idCorp?: string;
  onSuccess?: (data: TCreateCorpRes) => void;
}

export const useGetCorpProfileInfo = ({
  idCorp = "",
  onSuccess,
}: UseGetCorpBasicInfoProps) => {
  const queryGetCorpProfileInfoKey = useMemo(() => {
    return querygetCorporationProfileInfo._key(idCorp);
  }, [idCorp]);

  const { data, isLoading: isLoadingGetCorpProfileInfo } =
    useQueryWithCallbacks({
      queryKey: queryGetCorpProfileInfoKey,
      enabled: !!idCorp,
      queryFn: () => querygetCorporationProfileInfo(idCorp),
      onSuccess: onSuccess,
    });

  return {
    queryGetCorpProfileInfoKey,
    corporationProfileInfo: data,
    isLoadingGetCorpProfileInfo,
  };
};
